import { get, post } from '@/utils/request'

// 智慧大屏（SRM采购管理驾驶舱）统计接口
// 每个请求由 utils/request.js 的 getAppendParams() 自动注入 tenantId + mainBodyId（数据权限参考原代码）
// 年度多选：以 years 逗号分隔字符串传递（如 "2024,2025"），空=该块全量不过滤年度
// 各业务块年度独立：订单完成率/交货单执行/交货完成率/采购组织下钻 各自传自己的 years，切换只刷新对应块

const PROJECT = '/project-service/v1/dashboard'    // KPI 4 项 + 延迟天数分布 + 采购组织下钻
const ORDER = '/order-service/v1/dashboard'        // 订单状态分布 + 交货单执行 + 交货完成率
const SUPPLIER = '/supplier-service/v1/dashboard' // 供应商区域分布(地图) + 月度绩效TOP10
const GENERAL = '/general-service/v1'           // 子公司下拉（原系统 /org/supCompanyList）
const MDATA = '/mdata-service/v1'

// project-service：KPI 4 项 + 延迟天数分布（全量，不传年度参数）
export function getKpi (params) {
  return get(PROJECT + '/kpi', params || {})
}

// project-service：采购组织下钻（years 逗号分隔多选，空=全量）
export function getOrgDrill (params) {
  return get(PROJECT + '/orgDrill', params || {})
}

// project-service：采购组织下钻-导出明细（任务级，一行一任务，years 逗号分隔多选，空=全量）
export function exportDetail (params) {
  return get(PROJECT + '/exportDetail', params || {})
}

// order-service：订单完成率（years 多选，按 order_tbl.BEDAT 过滤）
export function getOrderStatus (params) {
  return get(ORDER + '/orderStatus', params || {})
}

// order-service：交货单执行（years 多选，按 delivery.CREATE_TIME 过滤）
export function getDeliveryStatus (params) {
  return get(ORDER + '/deliveryStatus', params || {})
}

// order-service：交货完成率周期（years 多选，按 delivery.CREATE_TIME 过滤）
export function getDeliveryRate (params) {
  return get(ORDER + '/deliveryRate', params || {})
}

// supplier-service：地图 + TOP10（TOP10 取最新年度 MAX(EVA_YEAR)，无年度参数）
export function getSupplierMap (params) {
  return get(SUPPLIER + '/overview', params || {})
}

// 子公司下拉数据源（大屏切换器）— 原系统 /org/supCompanyList，返回当前用户可见子公司(sys_org, ORG_TYPE='COM')列表
export function getSubCompanyList () {
  return get(GENERAL + '/org/supCompanyList', {})
}
